<h4 class="page-title">
  <button class="btn btn-outline-blue btn-rounded" (click)="voltar()">
    <i class="fa fa-arrow-left ct-point"></i>
  </button>
  <i class="fe-search ml-2"></i> Buscar contatos
</h4>

<div class="card filtro-avancado">
  <div class="card-body">

    <section class="crm-bloco">
      <div class="crm-titulo">
        <span class="crm-titulo-icone"><i class="fe-activity"></i></span>
        <div>
          <h5>Comportamento de compra</h5>
          <p>Combine segmento, ritmo e hábitos. Tudo vem dos pedidos e é atualizado sozinho.</p>
        </div>
      </div>

      <div class="crm-campo">
        <span class="crm-rotulo">Segmento atual</span>
        <div class="crm-chips">
          <button type="button" *ngFor="let s of segmentosCrm" class="crm-chip"
                  [class.ativo]="estaNaLista(filtro.status, s.codigo)" [style.--cor]="s.cor" [style.--fundo]="s.fundo"
                  (click)="alterneLista(filtro.status, s.codigo)">
            <i [class]="s.icone"></i>{{ s.nome }}
          </button>
        </div>
      </div>

      <div class="crm-grade">
        <div class="crm-campo" *ngFor="let f of faixasCrm">
          <span class="crm-rotulo">{{ f.rotulo }}</span>
          <div class="crm-faixa">
            <span class="crm-entrada"><em *ngIf="f.prefixo">{{ f.prefixo }}</em>
              <input type="number" min="0" [(ngModel)]="crm.faixas[f.chave].min" [name]="f.chave + 'Min'" placeholder="de"></span>
            <span class="crm-ate">a</span>
            <span class="crm-entrada"><em *ngIf="f.prefixo">{{ f.prefixo }}</em>
              <input type="number" min="0" [(ngModel)]="crm.faixas[f.chave].max" [name]="f.chave + 'Max'" placeholder="até"></span>
            <span class="crm-unidade" *ngIf="f.unidade">{{ f.unidade }}</span>
          </div>
        </div>
      </div>

      <div class="crm-campo">
        <span class="crm-rotulo">Pede só em</span>
        <div class="crm-dias">
          <button type="button" *ngFor="let d of diasDaSemana; let i = index" class="crm-dia"
                  [class.ativo]="crm.dias[i]" (click)="crm.dias[i] = !crm.dias[i]">{{ d }}</button>
        </div>
        <span class="crm-dica">Ex.: marque Sex, Sáb e Dom para achar quem só pede no fim de semana e puxar pedidos durante a semana.</span>
      </div>

      <div class="crm-grade">
        <div class="crm-campo">
          <span class="crm-rotulo">Produto favorito contém</span>
          <span class="crm-entrada largo"><i class="fe-search"></i>
            <input type="text" [(ngModel)]="crm.produto" name="crmProduto" placeholder="Ex.: pastel, x-bacon, açaí"></span>
        </div>
        <div class="crm-campo">
          <span class="crm-rotulo">Mudou de segmento há até</span>
          <div class="crm-faixa">
            <span class="crm-entrada"><input type="number" min="1" [(ngModel)]="crm.mudouHaDias" name="crmMudou" placeholder="7"></span>
            <span class="crm-unidade">dias</span>
          </div>
        </div>
      </div>

      <div class="crm-campo">
        <span class="crm-rotulo">Veio do segmento</span>
        <div class="crm-chips">
          <button type="button" *ngFor="let s of segmentosCrm" class="crm-chip pequeno"
                  [class.ativo]="estaNaLista(filtro.crmSegmentoAnterior, s.codigo)" [style.--cor]="s.cor" [style.--fundo]="s.fundo"
                  (click)="alterneLista(filtro.crmSegmentoAnterior, s.codigo)">{{ s.nome }}</button>
        </div>
        <span class="crm-dica">Ex.: segmento atual Esfriando + veio de Campeões = seus melhores clientes começando a sumir.</span>
      </div>

      <label class="crm-interruptor">
        <input type="checkbox" [(ngModel)]="filtro.crmRecebeCampanha.valor" name="crmRecebe">
        <span class="trilho"><span class="bolinha"></span></span>
        Só quem recebe campanha (sem bloqueio e com marketing ativo)
      </label>
    </section>

    <h5 class="section-title">Dados do Cliente</h5>

    <!-- Plano -->
    <div class="form-group">
      <label>Plano</label>
      <div class="form-control-wrapper">
        <div class="control-item">
          <kendo-combobox id="plano" name="plano" [(ngModel)]="filtro.plano.valor"
            [data]="planos" [suggest]="true" [allowCustom]="false"
            placeholder="Selecione um Plano" class="form-control" textField="label">
          </kendo-combobox>
        </div>
      </div>
    </div>

    <!-- Tag -->
    <div class="form-group" *ngIf="tags.length">
      <label>Tag</label>
      <div class="form-control-wrapper">
        <div class="control-item">
          <kendo-combobox id="tags" name="tags" [(ngModel)]="filtro.tag.valor"
            [data]="tags" [suggest]="true" [allowCustom]="false"
            placeholder="Selecione uma tag" class="form-control" textField="label">
          </kendo-combobox>
        </div>
      </div>
    </div>

    <!-- DDD -->
    <div class="form-group">
      <label>DDD</label>
      <div class="form-control-wrapper">
        <div class="checkbox-group">
          <input type="checkbox" id="apenasDddLocal" name="apenasDddLocal"
            kendoCheckBox class="k-checkbox" [(ngModel)]="filtro.apenasDddLocal.valor" />
          <label class="k-checkbox-label" for="apenasDddLocal">Apenas clientes do DDD local</label>
        </div>
      </div>
    </div>


    <!-- Aniversariantes -->
    <div class="form-group">
      <label>Aniversariantes</label>
      <div class="form-control-wrapper">
        <kendo-daterange>
          <kendo-dateinput kendoDateRangeStartInput [(value)]="filtro.aniversario.inicio"></kendo-dateinput>
          <span class="ml-2 mr-2">Até</span>
          <kendo-dateinput kendoDateRangeEndInput [(value)]="filtro.aniversario.fim"></kendo-dateinput>
        </kendo-daterange>
      </div>
    </div>

    <!-- Sexo -->
    <div class="form-group">
      <label>Sexo</label>
      <div class="form-control-wrapper">
        <div class="control-item">
          <kendo-combobox id="sexo" name="sexo" [(ngModel)]="filtro.sexo.valor" [data]="sexos"
            [suggest]="true" [allowCustom]="false" placeholder="Selecione" class="form-control"
            textField="label" [valueField]="'value'">
          </kendo-combobox>
        </div>
      </div>
    </div>


    <!-- Última compra -->
    <div class="form-group">
      <label>Última compra</label>
      <div class="form-control-wrapper">
        <div class="control-item">
          <kendo-combobox id="ultimasOperador" name="ultimasOperador" [(ngModel)]="filtro.ultimas.operador"
                          [data]="operadoresMais" [allowCustom]="false" placeholder="Selecione" class="form-control"
                          textField="label" [suggest]="true" [valueField]="'value'"
                          (selectionChange)="vaiUsarFiltro(filtro.ultimas,valores,unidades)">
          </kendo-combobox>
        </div>
        <div class="control-item small">
          <kendo-combobox id="ultimasValor" name="ultimasValor" [(ngModel)]="filtro.ultimas.valor"
                          [data]="valores" placeholder="Selecione" class="form-control" [suggest]="true"
                          textField="label" [valueField]="'value'">
          </kendo-combobox>
        </div>
        <div class="control-item small">
          <kendo-combobox id="ultimasUnidade" name="ultimasUnidade" [(ngModel)]="filtro.ultimas.unidade"
                          [data]="unidades" [allowCustom]="false" placeholder="Selecione" class="form-control"
                          [suggest]="true" textField="label" [valueField]="'value'">
          </kendo-combobox>
        </div>
        <span class="atras">atrás</span>
      </div>
    </div>




    <!-- Não foi notificado -->
    <div class="form-group mb-5">
      <label>Não foi notificado nos últimos</label>
      <div class="form-control-wrapper">
        <div class="control-item" style="flex: 1;">
          <kendo-combobox id="valorNN"
                          name="valorNN"
                          [(ngModel)]="filtro.naoNotificado.valor"
                          [data]="valores"
                          [suggest]="true"
                          [allowCustom]="false"
                          placeholder="Selecione"
                          class="form-control"
                          textField="label"
                          [valueField]="'value'">
          </kendo-combobox>
        </div>
        <div class="control-item" style="flex: 2;">
          <kendo-combobox id="unidadeNN"
                          name="unidadeNN"
                          [(ngModel)]="filtro.naoNotificado.unidade"
                          [data]="unidades"
                          [suggest]="true"
                          [allowCustom]="false"
                          placeholder="Selecione"
                          class="form-control"
                          textField="label"
                          [valueField]="'value'">
          </kendo-combobox>
        </div>
      </div>
    </div>


    <h5 class="section-title">Pedidos</h5>


    <!-- Qtd. Compras -->
    <div class="form-group">
      <label>Qtd. Compras</label>
      <div class="form-control-wrapper">
        <div class="control-item">
          <kendo-combobox id="operadorQtdcomprado" name="operadorQtdcomprado" [(ngModel)]="filtro.qtdComprado.operador"
                          [data]="operadores" [suggest]="true" [allowCustom]="false" placeholder="Selecione"
                          class="form-control" textField="label" [valueField]="'value'">
          </kendo-combobox>
        </div>
        <div class="control-item small">
          <input type="number" name="valorQtdcomprado" class="form-control" [(ngModel)]="filtro.qtdComprado.valor">
        </div>
      </div>
    </div>

    <!-- Ticket médio -->
    <div class="form-group">
      <label>Ticket médio</label>
      <div class="form-control-wrapper">
        <div class="control-item">
          <kendo-combobox id="operadorTicketMedio" name="operadorTicketMedio" [(ngModel)]="filtro.ticketMedio.operador"
            [data]="operadores" [suggest]="true" [allowCustom]="false" placeholder="Selecione"
            class="form-control" textField="label" [valueField]="'value'">
          </kendo-combobox>
        </div>
        <div class="control-item small">
          <input type="number" name="valorTicketmedio" class="form-control" [(ngModel)]="filtro.ticketMedio.valor">
        </div>
      </div>
    </div>

    <!-- Total comprado -->
    <div class="form-group">
      <label>Total comprado</label>
      <div class="form-control-wrapper">
        <div class="control-item">
          <kendo-combobox id="operadorTotalcomprado" name="operadorTotalcomprado" [(ngModel)]="filtro.totalComprado.operador"
            [data]="operadores" [suggest]="true" [allowCustom]="false" placeholder="Selecione"
            class="form-control" textField="label" [valueField]="'value'">
          </kendo-combobox>
        </div>
        <div class="control-item small">
          <input type="number" name="valorTotalcomprado" class="form-control" [(ngModel)]="filtro.totalComprado.valor">
        </div>
      </div>
    </div>


    <h5 class="section-title">Fidelidade</h5>

    <!-- Brindes -->
    <div class="form-group">
      <label>Brindes</label>
      <div class="form-control-wrapper">
        <div class="checkbox-group">
          <input type="checkbox" id="jaTrocou" name="jaTrocou" class="k-checkbox"
                 kendoCheckBox [(ngModel)]="filtro.jaTrocou.valor" />
          <label class="k-checkbox-label" for="jaTrocou">Já trocou por brindes</label>

          <input type="checkbox" id="podeTrocar" name="podeTrocar" class="k-checkbox"
                 kendoCheckBox [(ngModel)]="filtro.podeTrocar.valor" />
          <label class="k-checkbox-label" for="podeTrocar">Pode trocar por brindes</label>
        </div>
      </div>
    </div>

    <!-- Pontuação -->
    <div class="form-group">
      <label>Pontuação</label>
      <div class="form-control-wrapper">
        <div class="control-item">
          <kendo-combobox id="operadorPontuacao" name="operadorPontuacao" [(ngModel)]="filtro.pontuacao.operador"
                          [data]="operadores" [suggest]="true" [allowCustom]="false" placeholder="Selecione"
                          class="form-control" textField="label" [valueField]="'value'">
          </kendo-combobox>
        </div>
        <div class="control-item small">
          <input type="number" name="valorPontuacao" class="form-control" [(ngModel)]="filtro.pontuacao.valor">
        </div>
      </div>
    </div>

    <!-- Qtd. Visitas -->
    <div class="form-group">
      <label>Qtd. Visitas</label>
      <div class="form-control-wrapper">
        <div class="control-item">
          <kendo-combobox id="operadorQtdcomprado" name="operadorQtdcomprado" [(ngModel)]="filtro.qtdVisitas.operador"
                          [data]="operadores" [suggest]="true" [allowCustom]="false" placeholder="Selecione"
                          class="form-control" textField="label" [valueField]="'value'">
          </kendo-combobox>
        </div>
        <div class="control-item small">
          <input type="number" name="valorQtdcomprado" class="form-control" [(ngModel)]="filtro.qtdVisitas.valor">
        </div>
      </div>
    </div>

    <div class="botoes-fixos">
      <button class="btn btn-blue width-lg" (click)="filtre()">Pesquisar</button>
      <button class="btn btn-white width-lg" (click)="voltar()">Cancelar</button>
    </div>
  </div>
</div>
